import { YStack } from '@/components/ui/layout/layout';

import { RequestLoggerHeader } from './request-logger.header';
import { RequestLoggerTable } from './request-logger.table';

export function RequestLogger() {
  return (
    <YStack className="h-full px-4 py-4 sm:py-8 gap-4 max-w-screen-2xl mx-auto">
      <div>
        <h1 className="text-xl font-bold text-foreground">Request Logger</h1>
        <p className="text-foreground-muted text-sm">
          Monitor and analyze all requests from littlebird.
        </p>
      </div>
      <RequestLoggerHeader />
      <RequestLoggerTable />
    </YStack>
  );
}
